import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpIconComponent } from './icon.component';
import {
  ChevronLeftIconComponent,
  ChevronRightIconComponent,
  ClockIconComponent,
  HomeIconComponent,
  InfoIconComponent,
  OpAlarmIconComponent,
  OpAlarmSetIconComponent,
  OpCursorRectangleSelectIconComponent,
  OpCursorSelectIconComponent,
  OpEnterpriseAddonsIconComponent,
  OpEraseIconComponent,
  OpFirstPersonViewIconComponent,
  OpGridMenuIconComponent,
  OpGroupIconComponent,
  OpHierarchyIconComponent,
  OpNoHierarchyIconComponent,
  OpOrthographicPerspectiveIconComponent,
  OpResizerVerticalLinesIconComponent,
  OpScissorsIconComponent,
  OpThreedReturnDefaultIconComponent,
  OpViewFitToIconComponent,
  OpViewModalIconComponent,
  OpViewThreedIconComponent,
  PackageIconComponent,
  PersonIconComponent,
  QuestionIconComponent,
  ScreenFullIconComponent,
  ShareAndroidIconComponent,
  StarFillIconComponent,
  StarIconComponent,
  XIconComponent,
  BellFillIconComponent,
  OpGitlabIssueClosedIconComponent,
  OpGitlabLabelsIconComponent,
  OpGitlabIssueOpenIconComponent,
  OpGitlabMergeRequestClosedIconComponent,
  OpGitlabMergeRequestMergedIconComponent,
  OpGitlabMergeRequestOpenIconComponent,
  OpGitlabMergeRequestReadyIconComponent,
  OpGitlabPipelineStatusCanceledIconComponent,
  OpGitlabPipelineStatusCreatedIconComponent,
  OpGitlabPipelineStatusFailedIconComponent,
  OpGitlabPipelineStatusManualIconComponent,
  OpGitlabPipelineStatusPendingIconComponent,
  OpGitlabPipelineStatusPreparingIconComponent,
  OpGitlabPipelineStatusRunningIconComponent,
  OpGitlabPipelineStatusScheduledIconComponent,
  OpGitlabPipelineStatusSkippedIconComponent,
  OpGitlabPipelineStatusSuccessIconComponent,
  OpGitlabPipelineStatusWaitingIconComponent,
  XCircleIconComponent,
  KebabHorizontalIconComponent,
  ReadIconComponent,
  EyeIconComponent,
  EyeClosedIconComponent,
} from '@openproject/octicons-angular';

@NgModule({
  imports: [
    CommonModule,

    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    ClockIconComponent,
    HomeIconComponent,
    InfoIconComponent,
    OpAlarmIconComponent,
    OpAlarmSetIconComponent,
    OpCursorRectangleSelectIconComponent,
    OpCursorSelectIconComponent,
    OpEnterpriseAddonsIconComponent,
    OpEraseIconComponent,
    OpFirstPersonViewIconComponent,
    OpGridMenuIconComponent,
    OpGroupIconComponent,
    OpHierarchyIconComponent,
    OpNoHierarchyIconComponent,
    OpOrthographicPerspectiveIconComponent,
    OpResizerVerticalLinesIconComponent,
    OpScissorsIconComponent,
    OpThreedReturnDefaultIconComponent,
    OpViewFitToIconComponent,
    OpViewModalIconComponent,
    OpViewThreedIconComponent,
    PackageIconComponent,
    PersonIconComponent,
    QuestionIconComponent,
    ScreenFullIconComponent,
    ShareAndroidIconComponent,
    StarFillIconComponent,
    StarIconComponent,
    XIconComponent,
    BellFillIconComponent,

    OpGitlabIssueClosedIconComponent,
    OpGitlabLabelsIconComponent,
    OpGitlabIssueOpenIconComponent,
    OpGitlabMergeRequestClosedIconComponent,
    OpGitlabMergeRequestMergedIconComponent,
    OpGitlabMergeRequestOpenIconComponent,
    OpGitlabMergeRequestReadyIconComponent,
    OpGitlabPipelineStatusCanceledIconComponent,
    OpGitlabPipelineStatusCreatedIconComponent,
    OpGitlabPipelineStatusFailedIconComponent,
    OpGitlabPipelineStatusManualIconComponent,
    OpGitlabPipelineStatusPendingIconComponent,
    OpGitlabPipelineStatusPreparingIconComponent,
    OpGitlabPipelineStatusRunningIconComponent,
    OpGitlabPipelineStatusScheduledIconComponent,
    OpGitlabPipelineStatusSkippedIconComponent,
    OpGitlabPipelineStatusSuccessIconComponent,
    OpGitlabPipelineStatusWaitingIconComponent,

    XCircleIconComponent,

    KebabHorizontalIconComponent,
    ReadIconComponent,
    EyeIconComponent,
    EyeClosedIconComponent,
  ],
  declarations: [
    OpIconComponent,
  ],
  providers: [],
  exports: [
    OpIconComponent,

    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    ClockIconComponent,
    HomeIconComponent,
    InfoIconComponent,
    OpAlarmIconComponent,
    OpAlarmSetIconComponent,
    OpCursorRectangleSelectIconComponent,
    OpCursorSelectIconComponent,
    OpEnterpriseAddonsIconComponent,
    OpEraseIconComponent,
    OpFirstPersonViewIconComponent,
    OpGridMenuIconComponent,
    OpGroupIconComponent,
    OpHierarchyIconComponent,
    OpNoHierarchyIconComponent,
    OpOrthographicPerspectiveIconComponent,
    OpResizerVerticalLinesIconComponent,
    OpScissorsIconComponent,
    OpThreedReturnDefaultIconComponent,
    OpViewFitToIconComponent,
    OpViewModalIconComponent,
    OpViewThreedIconComponent,
    PackageIconComponent,
    PersonIconComponent,
    QuestionIconComponent,
    ScreenFullIconComponent,
    ShareAndroidIconComponent,
    StarFillIconComponent,
    StarIconComponent,
    XIconComponent,
    BellFillIconComponent,

    OpGitlabIssueOpenIconComponent,
    OpGitlabIssueClosedIconComponent,
    OpGitlabLabelsIconComponent,
    OpGitlabMergeRequestClosedIconComponent,
    OpGitlabMergeRequestMergedIconComponent,
    OpGitlabMergeRequestOpenIconComponent,
    OpGitlabMergeRequestReadyIconComponent,
    OpGitlabPipelineStatusCanceledIconComponent,
    OpGitlabPipelineStatusCreatedIconComponent,
    OpGitlabPipelineStatusFailedIconComponent,
    OpGitlabPipelineStatusManualIconComponent,
    OpGitlabPipelineStatusPendingIconComponent,
    OpGitlabPipelineStatusPreparingIconComponent,
    OpGitlabPipelineStatusRunningIconComponent,
    OpGitlabPipelineStatusScheduledIconComponent,
    OpGitlabPipelineStatusSkippedIconComponent,
    OpGitlabPipelineStatusSuccessIconComponent,
    OpGitlabPipelineStatusWaitingIconComponent,
    XCircleIconComponent,

    KebabHorizontalIconComponent,
    ReadIconComponent,
    EyeIconComponent,
    EyeClosedIconComponent,
  ],
})
export class IconModule {}
